<!--<div class="d-flex flex-column gap-2">-->
<!--  <div class="p-3">-->
<!--    <div class="col-12">-->
<!--      <object data="../../../content/images/Avitium_Ramp_Watch_normal.svg" type="image/svg+xml"-->
<!--              alt="avitium ramp watch logo" width="178.98px" height="43px">-->
<!--        &lt;!&ndash; Für Browser ohne SVG-Unterstützung &ndash;&gt;-->
<!--      </object>-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="h-divider"></div>-->
<!--  <div class="d-flex flex-column gap-2 p-3">-->
<!--    <div class="col-12">-->
<!--      <div class="d-flex flex-column gap-2">-->
<!--        <div>-->
<!--          <label for="userInput" class="form-label dark-blue roboto-font">E-mail</label>-->
<!--          <input type="text" class="form-control" id="userInput" [(ngModel)]="email" data-test="email-input">-->
<!--        </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="col-12 p-3" *ngIf="error || message">-->
<!--      <p>-->
<!--        <ngb-alert *ngIf="error" type="danger" [dismissible]="false">-->
<!--          <div class="roboto-font"><strong>Error!</strong> {{ error }}</div>-->
<!--        </ngb-alert>-->
<!--        <ngb-alert *ngIf="message" type="info" [dismissible]="false">-->
<!--          <div class="roboto-font"><strong>Info!</strong> {{ message }}</div>-->
<!--        </ngb-alert>-->
<!--      </p>-->
<!--    </div>-->
<!--    <div class="col-8 m-auto">-->
<!--      <div class="d-flex flex-column gap-3">-->
<!--        <button class="btn button-blue" [disabled]="!email.match('^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$')" (click)="reset()">-->
<!--          <ng-container *ngIf="!isBusy; else loading">-->
<!--            Reset password-->
<!--          </ng-container>-->
<!--          <ng-template #loading>-->
<!--            <app-loading-spinner></app-loading-spinner>-->
<!--          </ng-template>-->
<!--        </button>-->

<!--        <button class="btn button-blue" routerLink=".." data-test="back-button">-->
<!--            Back to login-->
<!--        </button>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->


      <div class="flex flex-column h-100">
          <div class="col-12">
            <div class="d-flex flex-column gap-2">
              <div>
                <label for="userInput" class="form-label dark-blue roboto-font">Email address</label>
                <input type="text" class="form-control" id="userInput" [(ngModel)]="email" data-test="email-input">
              </div>
            </div>
          </div>

        <div class="col-12 p-3 fs-16" *ngIf="error || message">
          <p>
            <ngb-alert *ngIf="error" type="danger" [dismissible]="false">
              <div><strong>Error!</strong> {{ error }}</div>
            </ngb-alert>
            <ngb-alert *ngIf="message" type="info" [dismissible]="false">
              <div>{{ message }}</div>
            </ngb-alert>
          </p>
        </div>
        <div class="sign-in">
          <div class="d-flex flex-column gap-3">
            <button class="btn button-blue" [disabled]="!email.match('^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$')" (click)="reset()">
              <ng-container *ngIf="!isBusy; else loading">
                Reset password
              </ng-container>
              <ng-template #loading>
                <app-loading-spinner></app-loading-spinner>
              </ng-template>
            </button>

            <button class="btn button-blue" routerLink=".." data-test="back-button">
              Back to login
            </button>
          </div>
        </div>

        <div class="fs-16">
<!--          <p>-->
<!--            <ngb-alert *ngIf="responseError || (user && user.role !== userRoles.RAMP_AGENT)" type="danger"-->
<!--                       data-test="error-alert"-->
<!--                       [dismissible]="false">-->
<!--              <strong>Error!</strong> You are not allowed to proceed because either the given credentials are-->
<!--              incorrect or you do not have the permission!-->
<!--            </ngb-alert>-->

<!--            <ngb-alert *ngIf="!responseError && !user" type="info" [dismissible]="false" data-test="info-alert">-->
<!--              <strong>Info!</strong> Please enter your credentials to proceed to the duty managers / ops controllers-->
<!--              application.-->
<!--            </ngb-alert>-->
<!--          </p>-->
        </div>
      </div>

